<template>
    <div>
            
        <div class="container-box">
                    
                    <div class="row">
                        <div style="background-color: rgb(127, 127, 127); padding: 5px;">
                            <h1 style="font-size: 20px; color: #eee;">
                                <b>OBTENE TU COTIZACION EN 5 MINUTOS 24/7</b>
                            </h1>
                        </div>
                        <div class="row" style="padding: 20px; text-align: left; background-color: white; opacity: 0.9;">

                            <div class="row">
                              <b-field custom-class="label" :label="'Nombre y apellido'">
                                <b-input v-model.trim="$store.state.budget.prop.client_name" custom-class="binput"></b-input>
                              </b-field>             
                            </div>

                            <div class="row">
                              <b-field custom-class="label" :label="'Email'">
                                <b-input v-model.trim="$store.state.budget.prop.client_email" custom-class="binput"></b-input>
                              </b-field>             
                            </div>

                            <div class="row">
                              <!---->
                               <span class="label">Whatsapp (Ingresar los 8 ultimos numeros sin 11 ni 15)</span>
                                <div class="row">
                                  <div class="label" style="float: left; width: 15%; font-size: 17px;">
                                    (011)
                                  </div>
                                  <div style="float: left; width: 85%;">
                                    <input  
                                      type="text" 
                                      v-mask="'####-####'" 
                                      class="nativeinput" 
                                      @keypress.native="isNumber" 
                                      v-model="$store.state.budget.prop.client_mobile">
                                  </div>
                                </div>
                                
                            </div>
                            <div class="row">
                              <div style="float: left; width: 48%;">
                                <b-field custom-class="label" :label="'Tipo de evento'">
                                <b-select v-model.trim="$store.state.budget.prop.event_type" expanded class="binput">
                                  <option 
                                    v-for="(data, index) in getEventTypes"
                                    :key="index"
                                    :value="data.id">
                                      {{data.event_name}}
                                  </option>
                                </b-select>
                              </b-field>             
                              </div>
                              <div style="float: left; width: 4%;">
                                  &nbsp;
                              </div>
                              <div style="float: left; width: 48%;">
                                <b-field custom-class="label" :label="'Invitados'">
                                <b-select v-model.trim="$store.state.budget.prop.guest_count" expanded class="binput">
                                  <option 
                                    v-for="(data, index) in getGuestCounter"
                                    :key="index"
                                    :value="data">
                                      {{data}}
                                  </option>
                                </b-select>
                              </b-field>             
                              </div>
                            </div>
                            
                            <div class="row" style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; flex-wrap: wrap;">
                                
                                <div style="width: 100%; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                                  <span class="label">Fecha del evento</span>
                                    <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                                        <div :style="{float: 'left', 
                                                width: $store.state.budget.prop.event_date.fixed_date ? '30%' : '48%'}">
                                          <b-select 
                                            v-model="$store.state.budget.prop.event_date.event_day"
                                            expanded 
                                            class="binputDD" 
                                            placeholder="DD">
                                            <option 
                                              v-for="(data, index) in getDays"
                                              :key="index"
                                              :value="data">
                                                  {{data}}
                                            </option>
                                          </b-select>
                                          
                                        </div>
                                        <div :style="{float: 'left', 
                                                    width: $store.state.budget.prop.event_date.fixed_date ? '2%' : '2%'}">
                                          &nbsp;
                                        </div>
                                        <div v-if="$store.state.budget.prop.event_date.fixed_date"
                                            :style="{float: 'left', 
                                                    width: $store.state.budget.prop.event_date.fixed_date ? '30%' : '48%'}">
                                          <b-select 
                                            v-model="$store.state.budget.prop.event_date.event_month"
                                            expanded 
                                            class="binputMM" 
                                            placeholder="MM">
                                            <option 
                                              v-for="(data, index) in monthNamePropArray"
                                              :key="index"
                                              :value="(index + 1)">
                                                  {{data}}
                                            </option>
                                          </b-select>
                                        </div>
                                        <div v-if="$store.state.budget.prop.event_date.fixed_date" style="float: left; width: 2%;">
                                          &nbsp;
                                        </div>
                                        <div :style="{float: 'left', 
                                                    width: $store.state.budget.prop.event_date.fixed_date ? '37%' : '48%'}">
                                          <b-select 
                                            v-model="$store.state.budget.prop.event_date.event_year"
                                            expanded 
                                            class="binputYY" 
                                            placeholder="YY">
                                            <option 
                                              v-for="(data, index) in getYear"
                                              :key="index"
                                              :value="data">
                                                  {{data}}
                                            </option>
                                          </b-select>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div style="width: 100%; text-align: center; margin-top: 20px;">
                                  <a @click="submit" class="button is-primary" style="padding: 5px; background-color: rgb(253, 93,220); font-size: 15px;">
                                      SOLICITAR PRESUPUESTO
                                  </a>
                                </div>
                              
                            </div>
                            <!--<hr>
                            <div class="row">
                                
                                  <span style="font-size: 10px; color: black">
                                  El usuario autoriza a “Don Quijote Recepciones” a ser contactado por cualquier medio electrónico incluyendo herramientas como Email, Email marketing, Whatsapp, Facebook, Facebook Messenger, Instagram, o similares para recibir ofertas, promociones o información general sobre el servicio brindado por la empresa. 
                                </span>
                             </div>
                          <div class="row" style="text-align: center;">

                                <a @click="submit" class="button is-primary">
                                    SOLICITAR PRESUPUESTO
                                </a>

                          </div>-->
                          
                        </div>
                        
                    </div>
                    
                </div>
              
        </div>
       
</template>

<script>

export default {
    data() {
      return {
        tnc: false
      }
    },
    computed: {
        getEventTypes() {
          return this.$store.state.budget.event_types
        },
        getGuestCounter() {
        	let gCount = 40;
                
			      let returnData = []
            while(gCount<=250) {
            	returnData.push(gCount)
                gCount = gCount + 1
            }

            return returnData

        },
        getDays() {

            let gCount = 1;
                
			      let returnData = []
            while(gCount<=31) {
            	returnData.push(gCount)
                gCount = gCount + 1
            }

            return returnData

        },
        getYear() {

            let initialyear = new Date().getFullYear();
                
            let gCount = 1

			      let returnData = []
            while(gCount<=5) {
            	returnData.push(initialyear)
                initialyear = initialyear + 1
                gCount ++
            }

            return returnData

        }
    },
    created() {
      
    },
    methods: {
        submit() {
          if(this.$store.state.budget.prop.client_name.length == 0) {
              return
          } 
          if(this.$store.state.budget.prop.client_email.length == 0) {
              return
          } 
          if(this.$store.state.budget.prop.client_mobile.length == 0) {
              return
          } 
          if(this.$store.state.budget.prop.event_type == 0) {
              return
          } 
          
          this.$router.push('/presupuesto')
        }
    }
}
</script>

<style scoped>

  .binputDD {
    
  }

  .binputMM {
    
  }

  .binputYY {
    
  }

  .checkboxPosition {
    top: 10px; position: relative;
  }

  @media screen and (max-width: 600px) {

    .checkboxPosition {
      top: 0px; 
      position: relative;
    }

    .binputDD {
      width: 70px;
    }

    .binputMM {
      width: 80px;
      left: -10px;
      position: relative;
    }

    .binputYY {
      width: 100px;
      left: -10px;
      position: relative;
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/Home/Index.vue